
import Vue from 'vue'
import DailyMenuOption from '@/model/DailyMenuOption'
import MenuGroupItem from '@/model/MenuGroupItem'
import MenuReservationItem from '@/model/MenuReservationItem'
import _ from 'lodash'
import Configuration from "@/model/Configuration";
import {GET_MODE} from "@/store/getter-types";
import InfoMenuGroupItemDialog from "@/components/order/InfoMenuGroupItemDialog.vue";
import Allergen from "@/model/Allergen";

interface ComponentData {
  selectedOption: DailyMenuOption[] | DailyMenuOption | undefined,
  showInfoDialog: boolean,
  selectedItem: any,
  selectedAllergens: Allergen[] | null
  isClicked: boolean
}

export default Vue.extend({
  name: 'GroupOptionSelector',
  components: {
    InfoMenuGroupItemDialog
  },

  props: {
    menuGroupItem: { type: Object as () => MenuGroupItem, required: true },
    subGroupItem: { type: Object as () => MenuGroupItem, required: true },
    reservationItem: { type: Object as () => MenuReservationItem | undefined },
    isManipulationAllowed: { type: Boolean, required: true },
    configuration: { type: Array as () => Configuration[]},
    settingsData: {type: Array as () => any[]},
    index: {type: Number},
    subGroupList: { type: Array as () => MenuGroupItem[]},
    isMultiplePortion: { type: Boolean, required: true },
    isPriseForTag: {type: Array as () => any[]},
},

  data (): ComponentData {
    return {
      selectedOption: undefined,
      showInfoDialog: false,
      selectedItem: '',
      selectedAllergens: [],
      isClicked: false
    }
  },

  computed: {

    isMultiplePortions () {
      return this.isMultiplePortion
    },

    isOrderListDisabled (): boolean {
      return !!(this.reservationItem && this.reservationItem.status === 'canceled' || this.reservationItem && this.reservationItem.status === 'delivered');
    },

    isDivider(): boolean {
      if(this.subGroupList) {
        const filteredSubGroupList: MenuGroupItem[] = this.subGroupList.filter((item: MenuGroupItem) => {
          const filteredList: DailyMenuOption[] = item.optionList.filter((item: DailyMenuOption) => item.offer)
          return filteredList.length > 0
        })
        return this.index !== 0 && this.index < filteredSubGroupList.length
      } else {
        return false
      }

    },

    isKioskMode (): boolean {
      return this.$store.getters[GET_MODE] === 'kiosk'
    },

    isSelectionMandatory (): boolean {
      return !!this.reservationItem
    },

    isSelectionAllowed (): boolean {
      if (!this.isManipulationAllowed) {
        return false
      }

      if (!this.reservationItem) {
        return true
      } else if (this.reservationItem && this.reservationItem.status === 'active') {
        return true
      }
      return true
    },

    statusClass (): string {
      return this.reservationItem && this.reservationItem.status || 'new-reservation'
    },

    isFoodItem (): boolean {
      const filteredData: DailyMenuOption[] = this.subGroupItem.optionList.filter((item: DailyMenuOption) => item.offer)
      return filteredData.length > 0
    },

    isPortionControl(): boolean {
      let condition: boolean = false
      const foundItem: any = this.settingsData.find((c: any) => c.key ===  'tenant.allow_portions_count')
        if(foundItem){
          condition = foundItem.value === 'true'
        } else {
          condition = false
        }

    return condition
    },

    isMultiple (): boolean {
      let condition: boolean = false
        this.subGroupItem.tags.forEach((i: any) =>{
          this.configuration.forEach((c: Configuration) => {
            const foundTag: any = c.tags.find((t: any) => t.id === i.id)
            if(foundTag){
              //@ts-ignore
              if(c && c.settings) {
                //@ts-ignore
                if(!c.settings['configuration_group.single_item']) {
                  condition = true
                }
              }
            }
          })
        })

      return condition
    },
  },

  watch: {
    menuGroupItem (): void {
      this.selectedOption= undefined
    },

    reservationItem (): void {
      this.updateSelectedOption()
    },

    selectedOption (newVal: DailyMenuOption | DailyMenuOption[] | undefined) {
      if(newVal instanceof Array) {
        if(newVal) {
          newVal.forEach((item: DailyMenuOption) => {
            let foundItem: any | null = this.reservationItem?.reservedOffers.find((i: any) => item.offer && i.dailyMenuOffer.id === item.offer!.id)
            if (foundItem) {
              item.offer!.amount = foundItem.amount
            } else {
              item.offer!.amount = 1
            }
          })
        }
      } else {
        if(newVal && newVal.offer) {
          let foundItem: any | null = this.reservationItem?.reservedOffers.find((i: any) => i.dailyMenuOffer.id === newVal.offer!.id)
          if (foundItem) {
            newVal.offer!.amount = foundItem.amount
          } else {
            newVal.offer!.amount = 1
          }
        }
      }

      this.$emit('selectedOptionChange', newVal)
    },

    restartReservation (newVal: boolean): void {
      if(newVal) {
        this.selectedOption = undefined
        this.$emit('restartOption')
      }
    },

    isClicked(newVal: boolean) {
      if(newVal) {
        this.isClicked = newVal
      }
    },
  },

  methods: {
    isPrice(a: any): boolean {
      let data: any[] | undefined = undefined
      let foundItem: any[] = []
      let price: boolean = false

      if (this.isPriseForTag) {
        data = this.isPriseForTag
        data.forEach((i: any) => {
          a.tags.forEach((item: any) => {
            if (i === item.id) {
              foundItem.push(item)
            }
          })
        })

        if (foundItem.length > 0) {
          price = true;
        } else {
          price = false;
        }
      }

      return price;
    },

    getFormattedPrice(item: any): any {
      return item.replace('.', ',')
    },


    getAllergensTitle (item: Allergen[]): string {
      if(item) {
        return item.map((i:Allergen) => {
          return i.code
        }).join(', ')
      } else {
        return ''
      }
    },

    onCloseInfoDialogClick () {
      this.showInfoDialog = false
    },

    onInfoButtonClick (item: any, i: Allergen[]) {
      this.showInfoDialog = true
      this.selectedItem = item
      this.selectedAllergens = i
    },

    isReservation (data: any): boolean {
      if(this.reservationItem && this.reservationItem.reservedOfferCollection) {
        const foundItem: any = this.reservationItem.reservedOfferCollection.find((item: any) => item.id === data.offer.id)
        return !!foundItem
      } else {
        return false
      }
    },

    isDataDisabled(data: any): boolean {
      return data.offer && data.offer.portionsCount === 0;
    },

    isFreePortion(data: any): boolean {
      return data.offer.portionsCount > data.offer.reservedPortionsCount

    },

    isSelectedOption(option: any): boolean {
      if(this.selectedOption && _.isArray(this.selectedOption)) {
        if (this.selectedOption.includes(option)) {
          return true
        } else {
          return false
        }
      } else if(this.selectedOption && _.isObject(this.selectedOption)) {
        if (this.selectedOption === option) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },

    iconClass (option: DailyMenuOption): string {
      if(this.selectedOption && _.isArray(this.selectedOption)) {
        if (this.selectedOption.includes(option)) {
          return 'fa fa-check-circle'
        } else {
          return 'fa fa-ban'
        }
      } else if(this.selectedOption && _.isObject(this.selectedOption)) {
        if (this.selectedOption === option) {
          return 'fa fa-check-circle'
        } else {
          return 'fa fa-ban'
        }
      } else {
        return 'fa fa-ban'
      }
      /*if (this.selectedOption === option ) {
        return 'fa fa-check-circle'
      } else {
        return 'fa fa-ban'
      }*/
    },

    onPlusPortionButtonClick (optionItem: DailyMenuOption) {
        optionItem.offer!.amount += 1
      this.$emit('newAmount',optionItem)
    },

    onMinusPortionButtonClick (optionItem: DailyMenuOption) {
      if(optionItem!.offer!.amount > 1) {
        optionItem!.offer!.amount -= 1
      }
      this.$emit('newAmount',optionItem)
    },

    updateSelectedOption (): void {
      if (this.reservationItem && this.reservationItem.reservedOfferCollection) {
        const reservedOffers: any[] = this.reservationItem.reservedOfferCollection
        const relevantItems = this.menuGroupItem.optionList.filter((slotItem: DailyMenuOption) => {
          if(slotItem.offer && slotItem.offer.id) {
            return !!reservedOffers.find((reservedOptionItem) => slotItem.offer!.id === reservedOptionItem.id)
          } else {
            return false
          }
        })
        if (relevantItems) {
          if(this.isMultiple) {
            this.selectedOption = relevantItems
          } else {
            relevantItems.forEach((item: any) => {
              this.selectedOption = item
            })

          }
        } else {
          this.selectedOption = undefined
        }
      } else {
        this.selectedOption = undefined
      }
    },

    getOfferPrice(slotItem: DailyMenuOption): string {
      if (this.reservationItem) {
        const offer = this.reservationItem.reservedOffers.find(o => o.dailyMenuOffer.id === (slotItem.offer!.id as unknown as number))

        if (offer) {
          return offer.agreedUnitPrice
        }
      }
      return slotItem.offer!.price
    },

  },

  mounted () {
    this.updateSelectedOption()
  }
})
